/** APP_TO_WEB_TOKEN 带下来的设备信息，供请求头使用。每个字段只保留一个驼峰名 */
export type AppRequestDevice = {
  deviceCode: string;
  deviceModel: string;
  deviceVersion: string;
  platform: string;
};

const device: AppRequestDevice = {
  deviceCode: '',
  deviceModel: '',
  deviceVersion: '',
  platform: '',
};

const text = (value: unknown) => (value == null ? '' : String(value).trim());

const pick = (payload: Record<string, unknown>, keys: string[]) => {
  for (const key of keys) {
    const value = text(payload[key]);
    if (value) return value;
  }
  return '';
};

/** 从 APP_TO_WEB_TOKEN payload 落设备字段。空值不覆盖已有值 */
export const applyAppRequestDevice = (payload: Record<string, unknown>) => {
  const deviceCode = pick(payload, ['deviceCode', 'devicecode']);
  const deviceModel = pick(payload, ['deviceModel', 'devicemodel']);
  const deviceVersion = pick(payload, ['deviceVersion', 'deviceversion']);
  const platform = pick(payload, ['platform']);
  if (deviceCode) {
    device.deviceCode = deviceCode;
    localStorage.setItem('deviceCode', deviceCode);
  }
  if (deviceModel) device.deviceModel = deviceModel;
  if (deviceVersion) device.deviceVersion = deviceVersion;
  if (platform) device.platform = platform;
};

export const getAppRequestDevice = () => device;
